import { render, staticRenderFns } from "./NoRecord.vue?vue&type=template&id=e9a82044&scoped=true&"
import script from "./NoRecord.vue?vue&type=script&lang=js&"
export * from "./NoRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a82044",
  null
  
)

export default component.exports